<template>
  <div data-app>
    <Header />
    <div style="margin-top: 84px" />
    <div v-if="profileAccess">
      <v-navigation-drawer class="side-nav" mini-variant-width="76" width="234" height="100vh" permanent expand-on-hover fixed>
        <v-list class="side-nav-list">
          <v-list-item :href="get_home_path + '/profile'" :ripple="false" class="side-nav-list-item">
            <v-img contain width="18" height="18" src="https://images.avishkaar.cc/misc/profile/side-nav/my-profile-icon.png"></v-img>
            <v-list-item-title class="side-nav-title">My Profile</v-list-item-title >
          </v-list-item>
          <v-list-item class="side-nav-list-item" :ripple="false">
            <v-img contain width="20" height="16" src="https://images.avishkaar.cc/misc/profile/side-nav/my-courses-icon.png"></v-img>
            <v-list-item-title class="side-nav-title">My Courses</v-list-item-title >
          </v-list-item>
          <v-list-item class="side-nav-list-item" :ripple="false">
            <v-img contain width="18" height="15" src="https://images.avishkaar.cc/misc/profile/side-nav/my-competitions-icon.png"></v-img>
            <v-list-item-title class="side-nav-title">My Competitions</v-list-item-title >
          </v-list-item>
          <v-list-item class="side-nav-list-item" :ripple="false">
            <v-img contain width="20" height="13" src="https://images.avishkaar.cc/misc/profile/side-nav/community-icon.png"></v-img>
            <v-list-item-title class="side-nav-title">Community</v-list-item-title >
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list class="side-nav-foot-list">
          <v-list-item :href="get_home_path + '/profile/settings'" :ripple="false" class="side-nav-list-item side-nav-list-item-active">
            <v-img contain width="19" height="17" :src="'https://images.avishkaar.cc/misc/profile/side-nav/settings-icon-orange.png'"></v-img>
            <v-list-item-title class="side-nav-title side-nav-title-active">Settings</v-list-item-title >
          </v-list-item>
          <v-list-item :href="get_web_path + '/logout'" :ripple="false" class="side-nav-list-item">
            <v-img contain width="17" height="15" src="https://images.avishkaar.cc/misc/profile/side-nav/logout-icon.png"></v-img>
            <v-list-item-title class="side-nav-title">Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <div class="my-settings">
        <MySettings />
      </div>
    </div>
    <div class="no-authorisee" v-else>{{loading}}</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Header from "../components/header.vue";
import MySettings from "../components/profile/MySettings.vue";
export default {
  name: "Profile",
  components: {
    Header,
    MySettings,
  },
  data() {
    return {
      get_web_path: process.env.VUE_APP_SITE_URL,
      get_home_path: process.env.NODE_ENV === "production" ? "https://home.avishkaar.cc" : "http://localhost:1111",
      profileAccess: false,
      loading: 'Loading...',
    };
  },
  watch: {
    profileData: function (newVal) {
      if (newVal.username != null) this.profileAccess = true;
    },
  },
  computed: {
    ...mapGetters({ profileData: "getUserProfileData" }),
  },
  methods: {
    ...mapActions(["fetchUserProfile"]),
  },
  created() {
    if (this.$cookies.get("userAccess") !== null) {
      this.fetchUserProfile();
    }
  },
  mounted() {
    if (this.profileData.username == null) this.loading = 'Not Authorized';
  }
};
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
.side-nav {
  .side-nav-list {
    margin-top: 84px;
    margin-bottom: 48px;
    height: 60vh;
  }
  .side-nav-list-item {
    border-left:5px solid #ffffff;
  }
  .side-nav-list-item::before {
    background-color: #ffffff;
  }
}
.side-nav:hover .side-nav-list-item-active {
    border-left:5px solid #e75b20;
}
.side-nav-title {
  text-align: left;
  margin-left: 10%;
  font-size: 0.875rem;
  color: #8d8d8d;
  font-family: Poppins;
  font-weight: 500;
}
.side-nav-title-active {
  color: #f36f2e;
  font-weight: 700;
}
.my-settings {
  width: 100vw;
}
.no-authorisee {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  color: #f36f2e;
  font-family: Poppins;
  font-weight: 500;
}
@media all and (max-width: 500px) {
  .side-nav {
    display: none;
  }
}
</style>